import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserManagementService } from '../../../service/user-management.service';
import { SupplierManagementService } from '../../../service/supplier-management.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'supplier-edit',
  templateUrl: './supplier-edit.component.html',
  styleUrls: ['./supplier-edit.component.css']
})
export class SupplierEditComponent implements OnInit {
  supplierData: any;
  message: string = '';
  msgs: Message[] = [];

  constructor(public route: ActivatedRoute, public dataService: UserManagementService, public supplierService: SupplierManagementService, public router: Router) {
    
  }

  ngOnInit() {

    this.getSupplier();
  }

  getSupplier() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.supplierService.getSupplier(id).subscribe(result => {
        this.supplierData = result;
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה באחזור הודעה');
      });
    } else {
      this.supplierData = {
        SupplierName: null,
        SupplierNum: null,
        Name: null,
        Phone1: null,
        Phone2: null,
        Address: null,
        Id: null,
        Active: true,
        EMail: null,
        Notes: null,
        SupplierInternalNum: null

      };
    }
  }


  onSubmit(f: NgForm) {
    if (f.valid) {
      // this.user.Id = this.route.snapshot.paramMap.get('id');
      this.supplierData.SupplierName = f.value.SupplierName;
      this.supplierData.SupplierNum = f.value.SupplierNum;
      this.supplierData.Phone1 = f.value.Phone1;
      this.supplierData.Phone2 = f.value.Phone2;
      this.supplierData.Address = f.value.Address;
      this.supplierData.EMail = f.value.EMail;
      this.supplierData.Active = f.value.Active;
      this.supplierData.Notes = f.value.Notes;
      this.supplierData.SupplierInternalNum = f.value.SupplierInternalNum;
      this.supplierService.SaveSupplier(this.supplierData).subscribe(res => {
        this.showMessage('success', '', 'פרטי ספק נשמרו');
            this.router.navigate(['suppliers-list']);
         
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בשמירת פרטי ספק');
      });
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/supplier-management/suppliers/supplier-edit/supplier-edit.component.ts